import script from "./DistribucionNotas.vue?vue&type=script&setup=true&lang=js"
export * from "./DistribucionNotas.vue?vue&type=script&setup=true&lang=js"

import "./DistribucionNotas.vue?vue&type=style&index=0&id=76ebda1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ebda1d"]])

export default __exports__